import React from "react";
import { getConfiguredLabel } from "../../common/commonHelper";
import {
  addIconFile,
  checkCircleIcon,
  deleteIcon,
  deleteIconFile,
  downloadIcon,
  editIcon,
  editIconFile,
  errorIcon,
  iIcon,
  passwordReset,
  reloadIcon,
  successIcon,
  svg,
  uploadIcon,
  resetIcon,
  docPublicIcon,
  docPrivateIcon,
  docGroupIcon
} from "../../common/labelConstants";

export const IconTypes = {
  Delete: "delete",
  Edit: "edit",
  Download: "download",
  CheckCircle: "checkCircle",
  Reload: "reload",
  Success: "success",
  Error: "error",
  Warning: "warning",
  UploadIcon: "uploadIcon",
  AddIcon_File: "AddIcon_File",
  EditIcon_File: "EditIcon_File",
  DeleteIcon_File: "DeleteIcon_File",
  PasswordReset: "passwordReset",
  Reset: "reset",
  GroupIcon: "groupIcon",
  PrivateIcon: "privateIcon",
  PublicIcon: "publicIcon"
};

export function RenderIcons(IconType) {
  switch (IconType) {
    case IconTypes.Delete:
      return (
        <React.Fragment>
          <span
            dangerouslySetInnerHTML={{
              __html: getConfiguredLabel(svg, deleteIcon),
            }}
          ></span>
        </React.Fragment>
      );
    case IconTypes.Edit:
      return (
        <React.Fragment>
          <span
            dangerouslySetInnerHTML={{
              __html: getConfiguredLabel(svg, editIcon),
            }}
          ></span>
        </React.Fragment>
      );
    case IconTypes.Download:
      return (
        <React.Fragment>
          <span
            dangerouslySetInnerHTML={{
              __html: getConfiguredLabel(svg, downloadIcon),
            }}
          ></span>
        </React.Fragment>
      );
    case IconTypes.CheckCircle:
      return (
        <React.Fragment>
          <span
            dangerouslySetInnerHTML={{
              __html: getConfiguredLabel(svg, checkCircleIcon),
            }}
          ></span>
        </React.Fragment>
      );
    case IconTypes.Reload:
      return (
        <React.Fragment>
          <span
            dangerouslySetInnerHTML={{
              __html: getConfiguredLabel(svg, reloadIcon),
            }}
          ></span>
        </React.Fragment>
      );
    case IconTypes.Success:
      return (
        <React.Fragment>
          <span
            dangerouslySetInnerHTML={{
              __html: getConfiguredLabel(svg, successIcon),
            }}
          ></span>
        </React.Fragment>
      );
    case IconTypes.Error:
      return (
        <React.Fragment>
          <span
            dangerouslySetInnerHTML={{
              __html: getConfiguredLabel(svg, errorIcon),
            }}
          ></span>
        </React.Fragment>
      );
    case IconTypes.Warning:
      return (
        <React.Fragment>
          <span
            dangerouslySetInnerHTML={{ __html: getConfiguredLabel(svg, iIcon) }}
          ></span>
        </React.Fragment>
      );
    case IconTypes.UploadIcon:
      return (
        <React.Fragment>
          <span
            dangerouslySetInnerHTML={{
              __html: getConfiguredLabel(svg, uploadIcon),
            }}
          ></span>
        </React.Fragment>
      );
    case IconTypes.Reset:
      return (
        <React.Fragment>
          <span
            dangerouslySetInnerHTML={{
              __html: getConfiguredLabel(svg, resetIcon),
            }}
          ></span>
          {/* <span>
            <svg
              id="refresh"
              xmlns="http://www.w3.org/2000/svg"
              width="15.014"
              height="15.978"
              viewBox="0 0 15.014 15.978"
            >
              <path
                id="Path_37526"
                data-name="Path 37526"
                d="M17.8,11.555a.879.879,0,0,0-1.008.749,5.684,5.684,0,0,1-1.625,3.213A5.771,5.771,0,1,1,7.009,7.355a5.694,5.694,0,0,1,3.11-1.6,5.493,5.493,0,0,1,1.641-.049,5.7,5.7,0,0,1,2.19.736l-1.156.2A.888.888,0,0,0,12.942,8.4a.9.9,0,0,0,.151-.013l3.1-.53a.888.888,0,0,0,.725-1.025l-.531-3.1a.888.888,0,1,0-1.75.3l.14.816a7.478,7.478,0,0,0-2.815-.91,7.194,7.194,0,0,0-2.156.066A7.439,7.439,0,0,0,5.753,6.1,7.546,7.546,0,0,0,16.425,16.772a7.45,7.45,0,0,0,2.126-4.21.888.888,0,0,0-.749-1.008Z"
                transform="translate(-3.547 -3)"
                fill="#3265aa"
              ></path>
            </svg>
          </span> */}
        </React.Fragment>
      );
    case IconTypes.AddIcon_File:
      return (
        <span
          dangerouslySetInnerHTML={{
            __html: getConfiguredLabel(svg, addIconFile),
          }}
        ></span>
      );
    case IconTypes.EditIcon_File:
      return (
        <span
          dangerouslySetInnerHTML={{
            __html: getConfiguredLabel(svg, editIconFile),
          }}
        ></span>
      );

    case IconTypes.DeleteIcon_File:
      return (
        <span
          dangerouslySetInnerHTML={{
            __html: getConfiguredLabel(svg, deleteIconFile),
          }}
        ></span>
      );
    case IconTypes.PasswordReset:
      return (
        <span
          dangerouslySetInnerHTML={{
            __html: getConfiguredLabel(svg, passwordReset),
          }}
        ></span>
      );
    case IconTypes.PublicIcon:
      return (
        <span className="rc_perms rc_public_icon"
          dangerouslySetInnerHTML={{
            __html: getConfiguredLabel(svg, docPublicIcon),
          }}
        ></span>
      );
    case IconTypes.PrivateIcon:
      return (
        <span className="rc_perms rc_private_icon"
          dangerouslySetInnerHTML={{
            __html: getConfiguredLabel(svg, docPrivateIcon),
          }}
        ></span>
      );
    case IconTypes.GroupIcon:
      return (
        <span className="rc_perms rc_group_icon"
          dangerouslySetInnerHTML={{
            __html: getConfiguredLabel(svg, docGroupIcon),
          }}
        ></span>
      );
    default:
      return <></>;
  }
}
